<template>
  <div>
    <material-card color="#ed2224" title="Sales Tracking" offset="0">
      <div slot="header-actions">
        <v-btn flat @click="resetFilters()">Clear Grid Filters</v-btn>
      </div>
    </material-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import { AgGridVue } from "ag-grid-vue";

  export default {
    components: {
      AgGridVue,
    },
    data: () => ({
      //AG-Grid
      columnDefs: null,
      rowData: null,
      pinnedBottomRowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "500px",
      search: "",

      // Filters
      searchDebounce: null,
      agGridFilter: {
        yearFilter: "All",
      },
      agGridRawFilter: {
        yearFilter: "All",
      },
      yearFilterArray: ["All"],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
        data: "stats/salesTrackingGeneral",
        aGGridActionMenu: "agGrid/aGGridActionMenu",
        selectedRowData: "agGrid/selectedRowData",
      }),
    },
    watch: {
      data: function (oldSE, newSE) {
        this.setGridData(this.data);
      },
    },
    mounted() {
      this.setYearFilterArray();
      this.columnDefs = [
        {
          headerName: "Year",
          field: "year",
          comparator: numberComparator,
        },
        {
          headerName: "Enquiries Total",
          field: "enquiriesCount",
        },
        {
          headerName: "Completed Enquiries",
          field: "completedEnquiriesCount",
        },
        {
          headerName: "Pending",
          field: "pendingEnquiriesCount",
        },
        {
          headerName: "Consumer",
          field: "consumerEnquiries",
        },
        {
          headerName: "Business/Orgs",
          field: "businessEnquiries",
        },
        {
          headerName: "Website Email Enq",
          field: "websiteEnquiries",
        },
        {
          headerName: "Website UC",
          field: "websiteCC",
          valueFormatter: (params) =>
            `$${formatter.format(params.data.websiteCC)}`,
        },
        {
          headerName: "Call Tracking Enq",
          field: "callTrackingEnquiries",
        },
        {
          headerName: "Call Tracking UC",
          field: "callTrackingCC",
          valueFormatter: (params) =>
            `${formatter.format(params.data.callTrackingCC)}`,
        },
        {
          headerName: "Other Enq",
          field: "otherEnquiries",
        },
        {
          headerName: "Other UC",
          field: "otherCC",
          valueFormatter: (params) => `${formatter.format(params.data.otherCC)}`,
        },
        {
          headerName: "Connection Enq",
          field: "connectionEnquiries",
        },
        {
          headerName: "Connection UC",
          field: "connectionCC",
          valueFormatter: (params) =>
            `${formatter.format(params.data.connectionCC)}`,
        },
        {
          headerName: "Affiliate Enq",
          field: "affiliateEnquiries",
        },
        {
          headerName: "Affiliate UC",
          field: "affiliateCC",
          valueFormatter: (params) =>
            `${formatter.format(params.data.affiliateCC)}`,
        },
        {
          headerName: "Repeat Enq",
          field: "repeatEnquiries",
        },
        {
          headerName: "Repeat UC",
          field: "repeatCC",
          valueFormatter: (params) => `${formatter.format(params.data.repeatCC)}`,
        },
        {
          headerName: "Total UC",
          field: "cC",
          valueFormatter: (params) => `${formatter.format(params.data.cC)}`,
        },
        {
          headerName: "Total Revenue",
          field: "revenue",
          valueFormatter: (params) => `${formatter.format(params.data.revenue)}`,
        },
      ];
      this.$store.dispatch("stats/loadSalesTrackingGeneral").then(() => {
        this.setGridData(this.data);
      });
    },
    methods: {
      setYearFilterArray() {
        let year = new Date().getFullYear();
        for (let i = year; i >= 2018; i--) {
          this.yearFilterArray.push(i);
        }
      },
      resetFilters() {
        this.gridApi.setFilterModel(null);
        this.gridApi.onFilterChanged();
      },
      updateFilter() {
        this.agGridFilter = this.agGridRawFilter;
        this.gridApi.onFilterChanged();
      },
      isExternalFilterPresent() {
        return this.agGridFilter.yearFilter !== "All";
      },
      doesExternalFilterPass(node) {
        let passed = 0;

        //Year Filter
        if (
          this.agGridFilter.yearFilter == "All" ||
          moment.utc(node.data.dateOfEnquiry).local().format("YYYY") ==
            this.agGridFilter.yearFilter
        ) {
          passed += 1;
        }

        if (passed == 1) {
          return true;
        } else {
          return false;
        }
      },

      setGridData(data) {
        let rowData = JSON.parse(JSON.stringify(data));
        rowData.pop();
        const pinnedRow = [data[data.length - 1]];

        this.gridApi.setRowData(rowData);
        this.gridApi.setPinnedBottomRowData(pinnedRow);
        setTimeout(() => {
          var allColumnIds = [];
          this.columnApi.getAllColumns().forEach(function (column) {
            if (column.colDef.suppressSizeToFit != true) {
              allColumnIds.push(column.colId);
            }
          });

          // this.gridApi.sizeColumnsToFit();
          this.columnApi.autoSizeColumns(allColumnIds, false);
        }, 50);
      },
      onQuickFilterChanged() {
        clearTimeout(this.searchDebounce);

        this.searchDebounce = setTimeout(() => {
          this.gridApi.setQuickFilter(this.search);
        }, 150);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        if (this.data.length != 0) {
          this.setGridData();
        }
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("agGrid/setSelectedRowData", cell.data);
        this.viewStockDetails();
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("agGrid/setAGGridActionMenuState", {});
      },
      viewStockDetails() {
        this.open(this.selectedRowData);
      },
      busName(id) {
        let business = this.businesses.find((b) => b.id == id);
        if (typeof business != "undefined") {
          return business.name;
        } else {
          return "";
        }
      },
      formatDate(date) {
        return date.slice(0, 11);
      },
      toggleForm() {
        if (!this.formOpen) {
          this.formData = {};
        }
        // this.formOpen = !this.formOpen;
        this.$router.push("/admin/salesEnquiry");
        setTimeout(() => {
          this.setGridData(this.salesEnquiries);
        }, 200);
      },
      addClicked() {
        if (!this.formOpen) {
          this.formData = {};
        }
        // this.formOpen = !this.formOpen;
        this.$router.push("/admin/salesEnquiry/new");
      },
      open(business) {
        this.$router.push(`/admin/salesEnquiry/${business.id}`);
        if (!this.formOpen) {
          this.image = null;
          this.saving = false;
          this.formData = business;
          this.formOpen = true;
          this.checkIfAlreadyOpened();
        }
      },
      checkIfAlreadyOpened() {
        if (
          (this.formData.status == "Unopened" ||
            this.formData.status == "Opened") &&
          this.userData.business_id == this.formData.business_id
        ) {
          this.formData.status = "Viewed";
          let today = new Date();
          this.formData.enquiryOpened = `${today.getFullYear()}-${
            today.getMonth() + 1
          }-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getMinutes()}`;
          this.$store.dispatch("business/salesEnquirySave", this.formData);
        }
      },
      sendReply() {
        this.emailLoading = true;
        try {
          let business = this.businesses.find(
            (b) => b.id == this.formData.business_id
          );
          let payload = {
            id: this.formData.id,
            business_id: this.formData.business_id,
            reply: this.replyFormData.reply,
            copySelf: this.replyFormData.copySelf,
            customerEmail: this.formData.email,
            customerName: this.formData.fullName,
            businessEmail: business.email,
            businessName: business.name,
          };
          this.$store
            .dispatch("emailSending/salesEnquirySendReply", payload)
            .then((result) => {
              this.emailLoading = false;
              this.replyEmailDialog = false;
              this.formData.status = "Reply Sent";
              this.$store.dispatch("business/loadSalesEnquiries");
              if (result.Result == "Success") {
                this.$swal({
                  title: "Success!",
                  text: `Your email has been sent.`,
                  type: "success",
                  confirmButtonText: "Ok",
                });
              } else {
                this.$swal({
                  title: "Error!",
                  text: `An Error has occured, Please try again later.`,
                  type: "success",
                  confirmButtonText: "Ok",
                });
              }
            });
        } catch (error) {
          this.emailLoading = false;
          this.$swal({
            title: "Error!",
            text: `An Error has occured, Please try again later.`,
            type: "error",
            confirmButtonText: "Ok",
          });
        }
      },
      currentBusinessEmail() {
        try {
          let business = this.businesses.find(
            (b) => b.id == this.formData.business_id
          );
          return business.email;
        } catch (error) {
          return "Unknown";
        }
      },
      save() {
        this.saving = true;
        for (const [key, value] of Object.entries(this.formData)) {
          if (value == undefined || value == null) {
            delete this.formData[key];
          }
        }
        if (this.formData.hasOwnProperty("id")) {
          this.$store
            .dispatch("business/salesEnquirySave", this.formData)
            .then(() => {
              // this.$swal("Saved", "This Sales Enquiry has been Saved", "success");
              this.toggleForm();
              this.saving = false;
            });
        } else {
          this.$store
            .dispatch("business/salesEnquiryAdd", this.formData)
            .then(() => {
              // this.$swal(
              //   "Added",
              //   "The Sales Enquiry has been created",
              //   "success"
              // );
              this.toggleForm();
              this.saving = false;
            });
        }
      },
      deleteItem() {
        this.$swal
          .fire({
            icon: "warning",
            title: "Are you sure you want to delete this sale enquiry card?",
            showDenyButton: true,
            showCancelButton: true,
            cancelButtonText: `Don't Delete`,
            confirmButtonText: `Delete`,
            confirmButtonColor: "red",
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.deleting = true;
              this.$store
                .dispatch("business/deleteSalesEnquiry", this.formData.id)
                .then(() => {
                  this.deleting = false;
                  this.toggleForm();
                  this.$swal(
                    "Deleted",
                    "The Sales Enquiry has been deleted",
                    "success"
                  );
                });
            }
          });
      },
      duplicateSalesEnquiry() {
        let payload = JSON.parse(JSON.stringify(this.formData));
        delete payload.id;
        delete payload.dateOfEnquiry;
        payload.repeatSale = 1;
        for (const [key, value] of Object.entries(payload)) {
          if (value == undefined || value == null) {
            delete payload[key];
          }
        }
        this.$store.dispatch("business/salesEnquiryAdd", payload).then(() => {
          this.toggleForm();
          this.saving = false;
        });
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
</script>

<style lang="css">
  #stats-grid .ag-body-horizontal-scroll {
    display: none;
  }
</style>